import { CustomDropdownProps } from '../../interfaces';
import { CustomDropdownWrapper } from './styles';
import classNames from 'classnames';
import './styles.scss';
import { FC } from 'react';

const CustomDropdown: FC<CustomDropdownProps> = props => {
  const {
    className,
    placement = 'bottomRight',
    trigger = ['click'],
    menu,
    ...rest
  } = props;

  // Items gated by a permission/condition are usually `null` - a menu of only
  // nulls is still empty, so render nothing instead of a dead trigger.
  if (!menu?.items?.some(Boolean)) return null;

  return (
    <CustomDropdownWrapper
      {...rest}
      menu={menu}
      trigger={trigger}
      placement={placement}
      overlayClassName="custom-dropdown-overlay"
      className={classNames(className, 'custom-dropdown')}
    />
  );
};

export default CustomDropdown;
